export const getTableColumns = () => [
  {
    title: 'Address',
    key: 'address',
    render: ({ address }) => address,
  },
  {
    title: 'Owning entity',
    key: 'owningEntity',
    render: ({ owningEntity }) => owningEntity,
  },
];
